import React, { useEffect } from "react";
import "./notification.scss";
import { FaCheckCircle } from "react-icons/fa";

const Notification = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(); // Tự động đóng sau 3 giây
    }, 2000);
    return () => clearTimeout(timer);
  }, [onClose]);

 return (
    <div className="notification">
      <FaCheckCircle className="icon" /> {/* Thêm icon dấu tích */}
      <span>{message}</span>
    </div>
  );
};


export default Notification;